import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  comments: [],
  commentsVisible: false,
  loading: false,
  error: null,
  selectedComment: null,
  showCommentHistory: false,
};

const docCommentsSlice = createSlice({
  name: "docComments",
  initialState,
  reducers: {
    setCommentsLoading(state, action) {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setCommentsError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    setComments(state, action) {
      state.comments = action.payload;
      state.loading = false;
      state.error = null;
    },
    addComment(state, action) {
      state.comments.unshift(action.payload);
    },
    updateComment(state, action) {
      const index = state.comments.findIndex(
        (comment) => comment.id === action.payload.id
      );
      if (index !== -1) {
        state.comments[index] = { ...state.comments[index], ...action.payload };
      }
    },
    removeComment(state, action) {
      state.comments = state.comments.filter(
        (comment) => comment.id !== action.payload
      );
    },
    toggleCommentsVisibility(state) {
      state.commentsVisible = !state.commentsVisible;
    },
    setCommentsVisibility(state, action) {
      state.commentsVisible = action.payload;
    },
    setSelectedComment(state, action) {
      state.selectedComment = action.payload;
    },
    clearSelectedComment(state) {
      state.selectedComment = null;
    },
    setShowCommentHistory(state, action) {
      state.showCommentHistory = action.payload;
    },
    clearComments(state) {
      state.comments = [];
      state.selectedComment = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  setCommentsLoading,
  setCommentsError,
  setComments,
  addComment,
  updateComment,
  removeComment,
  toggleCommentsVisibility,
  setCommentsVisibility,
  setSelectedComment,
  clearSelectedComment,
  setShowCommentHistory,
  clearComments,
} = docCommentsSlice.actions;

export default docCommentsSlice.reducer;
